import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const DaaSNotificationStatus = z.object({
  id: z.string(),
  processedOn: z.date().optional()
});

export type DaaSNotificationStatus = z.infer<typeof DaaSNotificationStatus>;

export enum NotificationEventType {
  NONE = 0,
  TEST = 99999
}

export const DaaSNotification = z.object({
  id: z.string(),
  notificationEventType: z.nativeEnum(NotificationEventType),
  propertyBag: z.any(),
  createdOn: z.date(),
  notificationStatuses: z.array(DaaSNotificationStatus)
});

export type DaaSNotification = z.infer<typeof DaaSNotification>;

const DaaSNotifications = z.object({
  items: z.array(DaaSNotification)
});
type DaaSNotifications = z.infer<typeof DaaSNotifications>;

const ReadNotifcationArgs = z.object({
  processedOn: z.string()
});
type ReadNotifcationArgs = z.infer<typeof ReadNotifcationArgs>;

export default c.router({
  getNotifications: {
    method: 'GET',
    path: '/msp/:mspId/customers/:customerId/notifications',
    responses: {
      200: DaaSNotifications,
      ...failedResponses
    },
    query: z.object({
      notificationType: z.number()
    })
  },
  getMspNotifications: {
    method: 'GET',
    path: '/msp/:mspId/notifications',
    responses: {
      200: DaaSNotifications,
      ...failedResponses
    },
    query: z.object({
      notificationType: z.number()
    })
  },
  readNotification: {
    method: 'PUT',
    path: '/msp/:mspId/customers/:customerId/notifications/:notificationId/notificationStatuses',
    responses: {
      200: DaaSNotification,
      ...failedResponses
    },
    body: ReadNotifcationArgs
  },
  readNotificationMsp: {
    method: 'PUT',
    path: '/msp/:mspId/notifications/:notificationId/notificationStatuses',
    responses: {
      200: DaaSNotification,
      ...failedResponses
    },
    body: ReadNotifcationArgs
  }
});
